module.exports = __webpack_public_path__ + "static/media/cams-ncp-ecmwf.a7ce5f10.png";